import logo from './logo.svg';
import './App.css';
import { Route, BrowserRouter as Router } from "react-router-dom";
import Header from './Componets/Layout/Header/Header';
import Home from './Componets/Layout/Home/Home';
import Footer from './Componets/Layout/Footer/Footer';
import AboutUs from './Componets/Layout/About Us/AboutUs';
import Gallery from './Componets/Layout/Gallery/Gallery';
import ContactUs from './Componets/Layout/ContactUs/ContactUs';
import Menu from './Componets/Layout/Menu/Menu';

function App() {
  return (
    <>
      <Router>
        <Header/>
          <Route exact path="/" component={Home}/>
          <Route exact path="/aboutus" component={AboutUs}/>
          <Route exact path="/gallery" component={Gallery}/>
          <Route exact path="/contactus" component={ContactUs}/>
          <Route exact path="/menu" component={Menu}/>
        <Footer/>
      </Router>
    </>
  );
}

export default App;